var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-demo"},[_c('dkbr-button-dial',{attrs:{"th":"th2","posx":"right","posy":"bottom","dir":"top","effect":"fling","icon":"play_for_work","iconFinal":"add","md-direction":"top","isHover":false}},[_c('div',{staticClass:"dkbr-demo__menu"},_vm._l((Object.entries(_vm.Elems)),function(ref){
var name = ref[0];
var El = ref[1];
return _c('dkbr-button',{key:name,staticClass:"dkbr-demo__menu-item",attrs:{"text":name,"isRaised":true,"isPrimary":true},nativeOn:{"click":function($event){_vm.Elem = El}}})}))]),_vm._l((Object.entries(_vm.Elems)),function(ref){
var name = ref[0];
var El = ref[1];
return (El == _vm.Elem)?_c('dkbr-demo-builder',{key:name,staticClass:"dkbr-demo__content",attrs:{"Elem":El}}):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd832c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/demo/vue/Demo.vue
// module id = ktxt
// module chunks = 8